import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import AbdominalAreaDeclaredJournalEvent from 'parog-web/models/abdominal-area-declared-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';
import formatNumberAsString from 'parog-web/utils/format-number-as-string';

export default class AbdominalAreaFormComponent extends CrudJournalEventBaseComponent {
  static override forcDisplayName = 'Mesure du périmètre abdominal';
  static override fullComponentId = 'abdominal-area/form';
  static override journalEventClass = AbdominalAreaDeclaredJournalEvent;

  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get toastMessage() {
    return this.session.patient
      ? {
          message: 'Votre mesure a bien été prise en compte.',
          title: 'Périmètre abdominal'
        }
      : super.toastMessage;
  }

  override get validations() {
    return this.journalEventClass.validations(this.intl);
  }

  override async save(): Promise<void> {
    this.changeset.set(
      'weight',
      formatNumberAsString(this.changeset.get('value'))
    );

    await super.save();
    this.analytics.trackPatientMeasurement('abdominal-area');
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <div class='two fields'>
          <div class='field'>
            <Form.Date
              @labelName='Date de la mesure'
              @propertyName='occurredAt'
            />
          </div>
          <div class='field'>
            <Form.NumberInput
              @labelName='Périmètre abdominal (cm)'
              @propertyName='value'
            />
          </div>
        </div>
        <div class='field'>
          <Form.TextArea @labelName='Commentaires' @propertyName='comments' />
        </div>
      </:content>
    </Provider>
  </template>
}
